export class AdSpireTracker {

    static orderThankyouPageView(order, basket, user) {

        if (order.site_id === 'kz') {
           return;
        }

        window.adspire_track = window.adspire_track || [];
        window.adspire_ip = user.numeric_ip;

        let orderItems = [],
            countItems = basket.length;

        for(let j = 0; j < countItems; j++)
        {
            let data = basket[j];
            let item = {
                cid         : data.category_id,
                cname       : data.category,
                pid         : data.id,
                pname       : data.name,
                price       : data.price,
                quantity    : data.quantity,
                vendor      : data.vendor,
                currency    : data.currency
            };

            if (data.is_offer) {
                item.group_id = data.offer_group_id;
                item.pid = data.offer_id;
            }

            orderItems.push(item);
        }

        let price = order.price,
            deliveryPrice = order.delivery_price;

        if (deliveryPrice > 0) {
            price = order.price - deliveryPrice;
        }

        window.adspire_track.push({
            TypeOfPage: 'confirm',
            Order: {
                id: order.id,
                id_user: order.user_id,
                totalprice: price,
                coupon: order.coupon,
                email: user.email_md5,
                usermail: (user.is_new_user_ecommerce) ? 'new' : 'old',
                type: (order.is_one_click) ? 'oneclick' : 'default',
                loyalty_card: '1',
                lastname: user.last_name,
                name: user.name
            },
            OrderItems: orderItems
        });
    }
}


// WEBPACK FOOTER //
// ./modules/tracker/adspire.js